import React from "react";
import { Controller } from "react-hook-form";
import { ReactComponent as AlertCircleIcon } from "../../../../assets/images/AlertCircleIcon.svg";
import { ReactComponent as IconInputError } from "../../../../assets/images/IconInputError.svg";

import { useShopifyApp } from "../../../../hooks/useShopifyApp";

import { Container, Error, Label, StyledInput, Wrapper } from "./styles";

const ModalInput = ({
  label,
  placeholder,
  type,
  control,
  name,
  disabled,
  error,
  rules,
  ...rest
}) => {
  const isShopifyApp = useShopifyApp();

  return (
    <Container>
      <Label>{label}</Label>

      <Wrapper>
        <Controller
          control={control}
          name={name}
          rules={rules}
          render={({ field }) => (
            <StyledInput
              {...field}
              {...rest}
              placeholder={placeholder}
              type={type}
              suffix={error && !isShopifyApp ? <IconInputError /> : <span />}
              status={error ? "error" : ""}
              disabled={disabled}
            />
          )}
        />

        {error && (
          <Error>
            {isShopifyApp && <AlertCircleIcon />}
            {error}
          </Error>
        )}
      </Wrapper>
    </Container>
  );
};

export default ModalInput;
